export default "__VITE_ASSET__G9Oa7Xjp__"